import { render, staticRenderFns } from "./select-game.vue?vue&type=template&id=c7936e8a&scoped=true&"
import script from "./select-game.vue?vue&type=script&lang=ts&"
export * from "./select-game.vue?vue&type=script&lang=ts&"
import style0 from "./select-game.vue?vue&type=style&index=0&id=c7936e8a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7936e8a",
  null
  
)

export default component.exports